import {defineStore} from 'pinia'
import {ref, computed, reactive} from 'vue'
import {fetchOddsmatcherData} from "@/services/oddsmatcher/fetchOddsmatcherData";
import {useMatchedBetStore} from '@/stores/MatchedBetStore'
import {useRouter} from "vue-router";


export const useOddsmatcherStore = defineStore('OddsmatcherStore', () => {
    const events = ref([]);
    const matchedBetStore = useMatchedBetStore();
    const userAuthorization = ref(1)
    const bookies = ref([])
    const router = useRouter();
    const filters = reactive({
        selectedSports: [],
        timeRange: 72,
        selectedBookies: [],
        selectedEvents: [],
        minOdds: '',
        maxOdds: '',
        betType: 'normal',
    });


    const fetchAndUpdateData = async (type = 'normal') => {
        try {
            const events_and_user_data = await fetchOddsmatcherData(type);
            events.value = events_and_user_data.events;
            userAuthorization.value = events_and_user_data.authentication
             if (userAuthorization.value <= 1) {
                filters.selectedBookies = ['bet365', 'coral'];
            }

             // todo make allowed bookie local settings and pass in serializer
            bookies.value = events_and_user_data.bookies.map(item => ({
                value: item[0],
                label: item[1]
            }));

            // Iterate through each event and matched bet, and add event-level data to each matched bet
            events.value.forEach(event => {
                if (event.matched_bets && event.matched_bets.length > 0) {
                    event.matchedBets = event.matched_bets
                    event.startDateTime = event.start_date_time
                    delete event.start_date_time
                    delete event.matched_bets
                    event.matchedBets.forEach(bet => {
                        bet.eventDescription = event.description;
                        bet.sport = event.sport;
                        bet.eventStart = event.startDateTime;

                        // Rename to camelCase
                        bet.backBet = bet.back_bet;
                        bet.backBet.bookieDisplay = bet.backBet.display_bookie
                        bet.layBet = bet.lay_bet;
                        bet.lay_bet.bookieDisplay = bet.layBet.display_bookie
                        bet.snrRating = bet.snr_rating
                        bet.srRating = bet.sr_rating

                        // Delete the old snake_case keys
                        delete bet.back_bet;
                        delete bet.lay_bet;
                        delete bet.snr_rating
                        delete bet.sr_rating
                        delete bet.backBet.display_bookie
                        delete bet.layBet.display_bookie

                    });
                }
            });

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const getFilteredMatchedBets = (filters = {}) => {
        // Apply event-level filters (sport and time)
        let filteredEvents = events.value;


        // Filter events by selected events
        if (filters.selectedEvents && filters.selectedEvents.length > 0) {
            filteredEvents = filteredEvents.filter(event =>
                filters.selectedEvents.includes(event.description)
            );
        }

        // Filter events by selected sports
        if (filters.selectedSports && filters.selectedSports.length > 0) {
            filteredEvents = filteredEvents.filter(event =>
                filters.selectedSports.includes(event.sport)
            );
        }

        // Filter events by time range
        if (filters.timeRange) {
            const now = new Date();
            const timeLimit = new Date(now.getTime() + filters.timeRange * 60 * 60 * 1000);
            filteredEvents = filteredEvents.filter(event =>
                new Date(event.startDateTime) <= timeLimit
            );
        }


        // Collect matched bets from filtered events
        let matchedBets = filteredEvents.reduce((acc, event) => {
            if (event.matchedBets && event.matchedBets.length > 0) {
                acc.push(...event.matchedBets);
            }
            return acc;
        }, []);

        // Apply bet-level filters

        // Filter by selected bookies
        if (filters.selectedBookies && filters.selectedBookies.length > 0) {
            matchedBets = matchedBets.filter(bet =>
                filters.selectedBookies.includes(bet.backBet.bookie)
            );
        }

        // Filter by minimum odds
        if (filters.minOdds) {
            matchedBets = matchedBets.filter(bet => {
                const odds = bet.backBet?.odds ?? bet.backBet?.win_odds ?? 0;  // Fallback to 0 if neither odds nor win_odds is present
                return odds >= parseFloat(filters.minOdds);
            });
        }

        // Filter by maximum odds
        if (filters.maxOdds) {
            matchedBets = matchedBets.filter(bet => {
                const odds = bet.backBet?.odds ?? bet.backBet?.win_odds ?? Infinity;
                return odds <= parseFloat(filters.maxOdds);
            });
        }

        // Return the filtered list of bets
        return matchedBets;
    };


    const handleSelectMatchedBet = (bet) => {
        matchedBetStore.backBetData.odds = bet.backBet.odds
        matchedBetStore.layBetData.odds = bet.layBet.odds
        matchedBetStore.oddsmatcherData.eventDescription = bet.eventDescription
        matchedBetStore.oddsmatcherData.eventStart = bet.eventStart
        matchedBetStore.oddsmatcherData.outcome = bet.selection
        matchedBetStore.oddsmatcherData.bookie = bet.backBet.bookie
        if (matchedBetStore.backBetData.stake === '') matchedBetStore.backBetData.stake = '10'
        router.push({name: 'matched-betting-calc'});
    };


    return {
        events,
        userAuthorization,
        bookies,
        filters,
        getFilteredMatchedBets,
        fetchAndUpdateData,
        handleSelectMatchedBet
    };
});